import React, { useContext, useState } from 'react'
import { useFormik } from 'formik';
import * as Yup from "yup";
import YupPassword from 'yup-password'
import clsx from 'clsx';
import { emailRegex, phone_regex } from '../../../../shared/const';
import { AppGeneralContext } from '../../../../shared/GeneralContext/GeneralContext';
import { ModalType, UserInfo, initialuserInfo } from '../../../types/types';
import { Button, InfoTooltip, TimedTooltip, TitlePage } from '../../../atoms';
import Footer from '../../../organism/Footer/Footer';
import { EditUserstartUpReq } from 'components/types/Api';
import { putEditUserstartUp } from 'api/Api';
import { useNavigate } from 'react-router-dom';
import { OverlayTrigger, Tooltip } from "react-bootstrap"
import  GenerateCode from '../../../molecules/ResetEmail/GenerateCode'; // Import the GenerateCode component


YupPassword(Yup)

const userInfoSchema = Yup.object().shape({
    firstName: Yup.string()
        .min(3, 'Too Short!, min 3 char')
        .max(70, 'Too Long!, max 70 char')
        .required('Please complete this required field.'),
    lastName: Yup.string()
        .min(3, 'Too Short!, min 3 char')
        .max(70, 'Too Long!, max 70 char')
        .required('Please complete this required field.'),
    email: Yup.string()
        .matches(emailRegex, 'Wrong email format')
        .required('Please complete this required field.'),
    phoneNumber: Yup.string()
        .matches(phone_regex, 'Phone number not correct')
        .required('Please complete this required field.'),
});

export const EditStartupProfile = () => {

    const {
        user,
        setModal,
        setErrorModal,
        getUserData,
        loginType,
        setClosedModal,
        setchangePWisOpen,
        setresetEmailisOPen,
    } = useContext(AppGeneralContext)
    const navigate = useNavigate();
    const [tooltipIsOpen, setTooltipIsOpen] = useState<boolean>()

    const initialUserInfo: EditUserstartUpReq = {
        firstName: user?.firstName ?? "",
        lastName: user?.lastName ?? "",
        phoneNumber: user?.phoneNumber ?? "",
        password: "",
        confirmPassword: "",
        email: user?.email ?? "",
    }

    const formik = useFormik<EditUserstartUpReq>({
        initialValues: initialUserInfo,
        validationSchema: userInfoSchema,
        enableReinitialize: true,
        onSubmit: async (values, { setSubmitting }) => {
            setSubmitting(true)
            setModal({ isOpen: true, type: ModalType.loading, title: "Loading", message: "Loading data, please wait" })

            let req: EditUserstartUpReq = {
                firstName: values.firstName,
                lastName: values.lastName,
                phoneNumber: values.phoneNumber,
            }

            if (values.password) {
                req = { ...req, password: values.password }
            }

            putEditUserstartUp(req).then(async (res) => {

                if (!res.isSuccess || !res.response) {
                    setErrorModal(res.error)
                    setSubmitting(false)
                    return
                }

                if (loginType) {
                    const reloaded = await getUserData(loginType)
                    if (reloaded) {
                        setClosedModal()
                    }
                }

                navigate('/start-up/profile')

            })
            setSubmitting(false)
        }
    })

    return (
        <>

            <div className="row p-0 m-0 pt-4">
                <div className='w-100'>
                    <div className='d-flex justify-content-between'>
                        <TitlePage as='h3' title={'edit profile'} />
                        <div className='d-flex'>
                            <span className='text-error' style={{ fontSize: "16px" }}>*</span>
                            <span className='text-error pe-md-4'>required</span>
                        </div>
                    </div>

                    <form onSubmit={formik.handleSubmit} className='mb-5' autoComplete='off' id='editUser'>
                        {/* firstName*/}
                        <div className='d-flex flex-wrap'>
                            <div className='col-xs-12 col-md-6 flex-grow-1 pe-md-4'>
                                <label className='text-black mt-3' htmlFor="firstName">First Name<sup className='text-error' style={{ fontSize: "16px" }}>*</sup></label>
                                <input
                                    autoComplete="new-password"
                                    placeholder='First Name'
                                    {...formik.getFieldProps('firstName')}
                                    className="form-input "
                                    type="text"
                                    onChange={formik.handleChange}
                                    onBlur={() => formik.setFieldTouched("firstName", true)}
                                    value={formik.values.firstName}
                                    name="firstName"
                                />
                                {formik.errors.firstName && formik.touched.firstName && <div className='text-error' id="firstName">{formik.errors.firstName}</div>}
                            </div>

                            {/* lastName */}
                            <div className='col-xs-12 col-md-6 flex-grow-1 pe-md-4'>
                                <label className='text-black mt-3' htmlFor="lastName">Last Name<sup className='text-error' style={{ fontSize: "16px" }}>*</sup></label>
                                <input
                                    autoComplete="new-password"
                                    placeholder='Last Name'
                                    {...formik.getFieldProps('lastName')}
                                    className="form-input"
                                    type="text"
                                    onChange={formik.handleChange}
                                    onBlur={() => formik.setFieldTouched("lastName", true)}
                                    value={formik.values.lastName}
                                    name="lastName"
                                />
                                {formik.errors.lastName && formik.touched.lastName && <div className='text-error' id="lastName">{formik.errors.lastName}</div>}
                            </div>

                            {/* email */}
                            <div className='col-xs-12 col-md-6 flex-grow-1 pe-md-4'
                                onMouseEnter={() => setTooltipIsOpen(true)}
                                onMouseLeave={() => setTooltipIsOpen(false)}>
                                <div className='d-flex flex-row align-items-center' >
                                    <label className='disabled text-black mt-3' htmlFor="email">Email<sup className='text-error' style={{ fontSize: "16px" }}>*</sup></label>
                                </div>
                                <OverlayTrigger
                                    trigger={['click', 'hover', 'focus']}
                                    show={tooltipIsOpen}
                                    delay={{ hide: 200, show: 200 }}
                                    overlay={(props) => (
                                        <Tooltip {...props} >
                                            <span>You can request a change of email address by contacting support at <a style={{ color: "var(--primary)" }} href="mailto:hello@innovationmatch.io" >hello@innovationmatch.io</a> </span>
                                        </Tooltip>
                                    )}
                                    placement="top">
                                    <input
                                        autoComplete="new-password"
                                        disabled
                                        {...formik.getFieldProps('email')}
                                        className="form-input disabled"
                                        type="text"
                                        onChange={formik.handleChange}
                                        onBlur={() => formik.setFieldTouched("email", true)}
                                        value={formik.values.email}
                                        name="email"
                                    />
                                </OverlayTrigger>
                                {formik.errors.email && formik.touched.email && <div className='text-error' id="email">{formik.errors.email}</div>}
                            </div>

                            {/* phoneNumber */}
                            <div className='col-xs-12 col-md-6 flex-grow-1 pe-md-4'>
                                <label className='text-black mt-3' htmlFor="phoneNumber">Mobile Phone Number<sup className='text-error' style={{ fontSize: "16px" }}>*</sup></label>
                                <input
                                    autoComplete="new-password"
                                    placeholder='Your mobile phone number'
                                    {...formik.getFieldProps('phoneNumber')}
                                    className="form-input"
                                    type="tel"
                                    onChange={formik.handleChange}
                                    onBlur={() => formik.setFieldTouched("phoneNumber", true)}
                                    value={formik.values.phoneNumber}
                                    name="phoneNumber"
                                />
                                {formik.errors.phoneNumber && formik.touched.phoneNumber && <div className='text-error' id="phoneNumber">{formik.errors.phoneNumber}</div>}
                            </div>

                            {/* password */}
                            {/* <div className='col-xs-12 col-md-6 flex-grow-1 pe-md-4'>
                                <label className='text-black mt-3' htmlFor="password">Password</label>
                                <input
                                    autoComplete="new-password"
                                    placeholder='Password'
                                    {...formik.getFieldProps('password')}
                                    className="form-input"
                                    type="password"
                                    onChange={formik.handleChange}
                                    onBlur={() => formik.setFieldTouched("password", true)}
                                    value={formik.values.password}
                                    name="password"
                                />
                                {formik.errors.password && formik.touched.password && <div className='text-error' id="password">{formik.errors.password}</div>}
                            </div> */}

                            {/* confirmPassword */}
                            {/* <div className='col-xs-12 col-md-6 flex-grow-1 pe-md-4'>
                                <label className='text-black mt-3' htmlFor="confirmPassword">Confirm Password</label>
                                <input
                                    autoComplete="new-password"
                                    placeholder='Confirm password'
                                    {...formik.getFieldProps('confirmPassword')}
                                    className="form-input"
                                    type="password"
                                    onChange={formik.handleChange}
                                    onBlur={() => formik.setFieldTouched("confirmPassword", true)}
                                    value={formik.values.confirmPassword}
                                    name="confirmPassword"
                                />
                                {formik.errors.confirmPassword && formik.touched.confirmPassword && <div className='text-error' id="confirmPassword">{formik.errors.confirmPassword}</div>}
                            </div> */}
                        </div>

                        <div className='d-flex justify-content-between mt-4 pe-md-4'>
                            <Button
                                type='button'
                                onClick={() => setchangePWisOpen(true)}
                                className='mt-1'
                                color='var(--white)'
                                background='var(--primary)'
                                borderColor='var(--primary)'
                                fontWeight={'800'}
                                uppercase primary text='Change password' />

                            <Button
                                type="submit"
                                className='mt-1 ms-5'
                                color='var(--white)'
                                background='var(--primary)'
                                borderColor='var(--primary)'
                                fontWeight={'800'}
                                uppercase primary text='save' />

                        </div>

                        <div className='d-flex justify-content-between mt-4 pe-md-4'>
                            <Button
                                type='button'
                                onClick={() => setresetEmailisOPen(true)}  

                                className='mt-1'
                                color='var(--white)'
                                background='var(--primary)'
                                borderColor='var(--primary)'
                                fontWeight={'800'}
                                uppercase primary text='Reset Email' />

                        </div>
                    </form >
                    <Footer />
                </div>
            </div>
        </>
    )
}

